/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { People2Icon16Light } from './People2Icon16Light';
import { People2Icon16Regular } from './People2Icon16Regular';
import { People2Icon16Solid } from './People2Icon16Solid';
import { People2Icon20Light } from './People2Icon20Light';
import { People2Icon20Regular } from './People2Icon20Regular';
import { People2Icon20Solid } from './People2Icon20Solid';
import { People2Icon24Regular } from './People2Icon24Regular';
import { People2Icon24Solid } from './People2Icon24Solid';
import { People2Icon32Regular } from './People2Icon32Regular';
import { People2Icon64Regular } from './People2Icon64Regular';
var sizes = {
    16: {
        light: People2Icon16Light,
        regular: People2Icon16Regular,
        solid: People2Icon16Solid,
    },
    20: {
        light: People2Icon20Light,
        regular: People2Icon20Regular,
        solid: People2Icon20Solid,
    },
    24: {
        regular: People2Icon24Regular,
        solid: People2Icon24Solid,
    },
    32: {
        regular: People2Icon32Regular,
    },
    64: {
        regular: People2Icon64Regular,
    },
};
export var People2Icon = forwardRef('People2Icon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
